export const USER_DETAILS = "USER_DETAILS";
export const ROUTES = "ROUTES";
export const NOTIFICATION_COUNT = "NOTIFICATION_COUNT";
